function Prizes({ isQualified }: { isQualified?: boolean }) {
  return (
    <>
      {/*1*/}
      <div
        className={`font-jost relative overflow-hidden w-full min-h-10 lg:min-h-20 flex items-center border [background:linear-gradient(102deg,#F7F7F7_11.25%,#FFE1C2_88.75%)] rounded-[4px] lg:rounded-lg border-solid border-[rgba(0,0,0,0.04)] lg:pl-[114px] ${isQualified ? "pl-[44px]" : "pl-[60px] min-w-[198px]"}`}>
        <div
          className={
            "absolute right-0 top-0 inline-flex justify-center items-center gap-2.5 bg-[#FF9B33] min-h-2.5 px-1 lg:px-3 lg:py-0.5 rounded-[0_4px] lg:rounded-[0_8px]"
          }>
          <span
            className={
              "text-white [text-shadow:0_0_4px_rgba(255,130,0,0.30)] text-[7px] font-medium leading-[8px] lg:text-xs lg:leading-4"
            }>
            GRAND PRIZE
          </span>
        </div>
        <img
          src={"/assets/images/refer-a-friend/prize-car.png"}
          alt="car"
          className={`lg:w-[118px] h-auto absolute lg:top-0 lg:bottom-auto lg:-left-3 ${isQualified ? "top-0 -left-3 w-[53px] " : "inset-y-0 -left-[5px] w-[59px] "}`}
          width={118}
          height={72}
        />
        <div
          className={`text-secondary lg:text-base lg:leading-[22px] font-medium ${isQualified ? "text-[10px] leading-3 pt-1" : "text-[11px] leading-[14px]"}`}>
          <span className={"text-primary"}>1x</span> <span className={"text-[#28282B]"}>McLaren 570 GT</span>
          <br />
          or £45,000 cash
        </div>
      </div>

      {/*2*/}
      <div
        className={`font-jost relative overflow-hidden w-full min-h-10 lg:min-h-20 flex items-center border [background:linear-gradient(135deg,#F1F5F9_0%,#F5F5F5_100%)] rounded-[4px] lg:rounded-lg border-solid border-[rgba(0,0,0,0.04)] lg:pl-[114px] ${isQualified ? "pl-[44px]" : "pl-[60px] min-w-[198px]"}`}>
        <div
          className={
            "absolute right-0 top-0 inline-flex justify-center items-center gap-2.5 bg-[#79A1FF] min-h-2.5 px-1 lg:px-3 lg:py-0.5 rounded-[0_4px] lg:rounded-[0_8px]"
          }>
          <span
            className={
              "text-white [text-shadow:0_0_4px_rgba(255,130,0,0.30)] text-[7px] font-medium leading-[8px] lg:text-xs lg:leading-4"
            }>
            CASH PRIZES
          </span>
        </div>
        <img
          src={"/assets/images/refer-a-friend/prize-cash.png"}
          alt="car"
          className={`lg:w-[118px] h-auto absolute my-auto inset-y-0 lg:-left-1 ${isQualified ? "-left-2 w-[53px] " : "-left-[5px] w-[59px] "}`}
          width={118}
          height={72}
        />
        <div
          className={`text-secondary lg:text-base lg:leading-[22px] font-medium ${isQualified ? "text-[10px] leading-3 pt-1" : "text-[11px] leading-[14px]"}`}>
          <span className={"text-primary"}>125x</span> <span className={"text-[#28282B]"}>£200 Cash</span>
        </div>
      </div>
    </>
  );
}

export default Prizes;
